import React from 'react';
import {Navigate} from 'react-router-dom';

import {useTranslations} from 'src/components/TranslationsContext';
import {LoggedInAuth, LoggedOutAuth} from 'src/hooks/useAuth';

export type Props = {
  auth: LoggedInAuth | LoggedOutAuth;
};

export default function SignOut({auth}: Props) {
  const {t} = useTranslations();

  React.useEffect(() => {
    if (auth.status === 'logged in') {
      auth.signOut();
    }
  }, [auth]);

  if (auth.status === 'logged in') {
    return <div>{t('loading')}</div>;
  }
  // We do our own Redirect rather than use WithLoggedInProvider because
  // WithLoggedInProvider automatically generates a URL to /signin that
  // redirects back to the current page on success.
  //
  // If we did that here we’d just redirect back to logging the user out
  // after they logged in.
  return <Navigate to="/signin" replace />;
}
